export const dynamicReport = {
  filters: [
    {
      seq: 1,
      key: "start_date",
      label_th: "Start Date",
      label_en: "Start Date",
      placeholder_th: "Start Date",
      placeholder_en: "Start Date",
      type_id: 11,
      type_desc: "DateTime Picker",
      required: false,
      value: "",
      api_key: "StartDate",
      field_property: {
        display_type: 3,
        font_size: null,
        width: "40%",
        height: null,
      },
    },
    {
      seq: 2,
      key: "end_Date",
      label_th: "End Date",
      label_en: "End Date",
      placeholder_th: "End Date",
      placeholder_en: "End Date",
      type_id: 11,
      type_desc: "DateTime Picker",
      required: false,
      value: "",
      api_key: "EndDate",
      field_property: {
        display_type: 3,
        font_size: null,
        width: "40%",
        height: null,
      },
    },
  ],
};

export const defaultReport = {
  customer: "bcrm_report_customer",
  inventory: "bcrm_report_inventory",
  privilege: "bcrm_report_privilege",
  flash_deal: "bcrm_report_flash_deal_campaign",
  banner: "bcrm_report_banner",
  article: "bcrm_report_article",
  document: "bcrm_report_document",
  lucky_winner: "bcrm_report_luckywinner",
  tag: "bcrm_report_tag",
  fulfillment: "bcrm_report_fulfillment",
  quiz_dashboard: "bcrm_report_quiz_dashboard_summary_by_quiz",
  survey_dashboard: "bcrm_report_survey_detail",
};

export const defaultReportCategory = {
  customer: "bcrm-category-customer",
  inventory: "bcrm-category-inventory",
  privilege: "bcrm-category-privilege",
  flash_deal: "bcrm-category-flashdeal",
  banner: "bcrm-category-banner",
  article: "bcrm-category-article",
  document: "bcrm-category-document",
  lucky_winner: "bcrm-category-luckywinner",
  tag: "bcrm-category-tag",
  fulfillment: "bcrm-category-ffm",
  quiz_dashboard: "bcrm-category-quiz-dashboard",
  survey_dashboard: "bcrm-category-survey",
};

export const defaultReportFilterType = {
  module: "bcrm_report",
  category: "bcrm_report_category",
  filter: "bcrm_report_filter",
};
